<template>
  <div class="member-item" :class="{checked:checked}">{{name}}</div>
</template>

<script>
export default {
	props:{
		name:{
			type:String,
			require:true
		},
		checked:{
			type:Boolean,
			require:true
		}
	}

}
</script>

<style lang="scss" scoped>
.member-item{
	display: inline-block;
	padding: 3px 9px;
	border: 1px #e6e3e3 solid;
	font-size: 14px;
	border-radius: 4px;
	color: #4a4a4a;
	cursor: pointer;
  &.checked{
    background: #F0722B;
    color: #fff;
  }
}
</style>
